var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons+Indicators / Notification / Tick / White / Large") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons+Indicators-/-Notification-/-Tick-/-White-/-Large",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 6.42857143,
    y: 6.42857143,
    width: 23.1428571,
    height: 23.1428571
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,36 C27.9411255,36 36,27.9411255 36,18 C36,8.0588745 27.9411255,0 18,0 C8.0588745,0 0,8.0588745 0,18 C0,27.9411255 8.0588745,36 18,36 Z M26.6733498,10.2369308 C27.0947813,9.78038458 27.8065229,9.75191839 28.2630692,10.1733498 C28.7196154,10.5947813 28.7480816,11.3065229 28.3266502,11.7630692 L14.4803607,26.7630692 C14.034903,27.2456436 13.2725181,27.2456436 12.8270604,26.7630692 L6.67334985,20.0966147 C6.25191839,19.6400684 6.28038458,18.9283268 6.73693085,18.5068954 C7.19347712,18.0854639 7.9052187,18.1139301 8.32665015,18.5704764 L13.6537106,24.341402 L26.6733498,10.2369308 Z",
    id: "Combined-Shape"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.deab33c1e91055ae3d7ae473ae75f9d3.svg";
export { ForwardRef as ReactComponent };